export default __webpack_public_path__ + "static/media/scooter.icon.8b09240f.svg";